/* SOFT SKILLS USERS */
export const GET_SOFTSKILLS_USERS_ALL = "GET_SOFTSKILLS_USERS_ALL"
export const GET_SOFTSKILLS_USERS_ALL_SUCCESS =
  "GET_SOFTSKILLS_USERS_ALL_SUCCESS"
export const GET_SOFTSKILLS_USERS_ALL_ERROR = "GET_SOFTSKILLS_USERS_ALL_ERROR"
